import 'url-search-params-polyfill';

import messenger from "./images/messenger.png";
import messenger_2x from "./images/messenger_2x.png";
import mobile_messenger from "./images/mobile_messenger.png";
import mobile_messenger_2x from "./images/mobile_messenger_2x.png";

import music from "./images/music.png";
import music_2x from "./images/music_2x.png";
import mobile_music from "./images/mobile_music.png";
import mobile_music_2x from "./images/mobile_music_2x.png";

import team from "./images/team.png";
import team_2x from "./images/team_2x.png";
import mobile_team from "./images/mobile_team_2x.png";
import mobile_team_2x from "./images/mobile_team_2x.png";

// import theme from "./images/theme.png";
// import theme_2x from "./images/theme_2x.png";
// import mobile_theme from "./images/mobile_theme.png";
// import mobile_theme_2x from "./images/mobile_theme_2x.png";

import shops from "./images/shops.png";
import shops_2x from "./images/shops_2x.png";
import mobile_shops from "./images/mobile_shops.png";
import mobile_shops_2x from "./images/mobile_shops_2x.png";


import stories from "./images/stories.png";
import stories_2x from "./images/stories_2x.png";
import mobile_stories from "./images/mobile_stories.png";
import mobile_stories_2x from "./images/mobile_stories_2x.png";


const hostName = window.landing && window.landing.getHostName();

// const searchParams = new URLSearchParams(window.location.search);
// const langauge = Number(searchParams.get('language'));
// const parentLangauge = Number(searchParams.get('parent_language'));
// const isEng = langauge === 3 || parentLangauge === 3;
const isEng = false;

export default {
  hostName: hostName,
  isEng: isEng,
  isGooglePlayAvailable: !isEng,
  sections: [
    {
      id: 1,
      slogan:
        isEng ?
        'Send Quick Responses' :
        'Всё самое важное и интересное',
      text:
        isEng ?
        'Notifications about&nbsp;new messages will instantly appear on&nbsp;your phone so you’re always in&nbsp;touch.' :
        'Посты друзей, обновления любимых сообществ и рекомендации по интересам — в вашей ленте',
      images: {
        desktop: [messenger, messenger_2x],
        mobile: [mobile_messenger, mobile_messenger_2x]
      },
      caption: 'Приложение ВКонтакте',
    },
    {
      id: 2,
      slogan:
        isEng ?
        'Music You Can Take with&nbsp;You' :
        'Музыка, которая всегда с&nbsp;вами',
      text:
        isEng ?
        'All VK music is available on&nbsp;your Android or iOS device.' :
        'Слушайте новинки, любимые треки и песни, проверенные временем',
      images: {
        desktop: [music, music_2x],
        mobile: [mobile_music, mobile_music_2x]
      }
    },
    {
      id: 3,
      slogan:
        isEng ?
        'Calls' :
        'Бесконечная лента клипов',
      text:
        isEng ?
        'Surprise your friend with a&nbsp;funny mask in a&nbsp;video call or get the whole family together for a&nbsp;group call.' :
        'Будьте в тренде — с короткими роликами',
      images:{
        desktop: [team, team_2x],
        mobile: [mobile_team, mobile_team_2x]
      }
    },
    // {
    //   id: 4,
    //   slogan:
    //     isEng ?
    //     'Dark Mode' :
    //     'Тёмная тема',
    //   text:
    //     isEng ?
    //     'Use this mode on&nbsp;VK, and&nbsp;your eyes will thank you.' :
    //     'Пользуйтесь ВКонтакте так, чтобы ваши глаза были вам благодарны.',
    //   images: {
    //     desktop: [theme, theme_2x],
    //     mobile: [mobile_theme, mobile_theme_2x]
    //   }
    // },
    {
      id: 5,
      slogan:
        isEng ?
        'Convenient Story Editor' :
        'Ваша жизнь — в историях',
      text:
        isEng ?
        'Share exciting moments in&nbsp;stories, tag friends and add hashtags.' :
        'Делитесь с друзьями любимыми моментами — стикеры и шаблоны сделают их ещё ярче',
      images: {
        desktop: [stories, stories_2x],
        mobile: [mobile_stories, mobile_stories_2x]
      },
    },
    {
      id: 6,
      slogan: 'Шопсы — контент с товарами',
      text: 'Делайте покупки прямо из ленты и зарабатывайте, снимая свои шопсы',
      images: {
        desktop: [shops, shops_2x],
        mobile: [mobile_shops, mobile_shops_2x]
      },
      footer: {
        slogan:
          isEng ?
          'VK Has a&nbsp;Mobile Version as&nbsp;Well' :
          'Будьте на связи',
        text:
          isEng ?
          'To access the&nbsp;responsive mobile version of&nbsp;vk.com, just enter the&nbsp;following URL on&nbsp;your phone:' :
          'Чтобы вернуть push-уведомления на iOS, перейдите по этой ссылке с iPhone и следуйте инструкции',
        text1: 'Чтобы вернуть push-уведомления на iOS, перейдите',
        linkText: 'по этой ссылке',
        text2: 'с iPhone и следуйте инструкции',

      },
    },
  ],
  page: {
    title: isEng ?
      'Official VK app: download for Android and iOS' :
      'Официальное приложение ВКонтакте: скачать для Android и iOS',
  },
  fixed: {
    directDownloadToAndroid:
      isEng ?
      'Download Directly to Android' :
      'Cкачать напрямую на Android',
    team: isEng ?
      'VK Team' :
      'Команда ВКонтакте',
    vk: isEng ?
      'VK' :
      'ВКонтакте',
    title:
      isEng ?
      'VK Is Always with You' :
      'Будьте ВКонтакте',
    description:
      isEng ?
      'Install the official VK app on&nbsp;your phone to&nbsp;chat with others and stay up&nbsp;to&nbsp;date on the&nbsp;latest news no&nbsp;matter where you are.' :
      'Следите за новостями, общайтесь с близкими, развлекайтесь, творите, зарабатывайте',
    qrCodeText:
      isEng ?
      'Scan the&nbsp;QR&nbsp;code on&nbsp;your phone to download VK' :
      'Отсканируйте QR-код с&nbsp;помощью телефона, чтобы скачать ВКонтакте',
    ruStoreDescription: 'для Android',
    pwaDescription: 'для iOS',
  }
}
